import React, {Component} from 'react';

import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import cssAnimation from 'css-animation';
import {request} from "../helper/APIUtils";
import {showAxiosError} from "../helper/helper";
import Alert from "react-s-alert";
import StickButton from "./StickButton";
import NavBarKS from "./NavBarKS";


const STYLE = `
.collapse {
  overflow: hidden;
  display: block;
}

.collapse-active {
  transition: height 0.3s ease-out;
}
`;

function animate(node, show, done) {
	let height = node.offsetHeight;
	return cssAnimation(node, 'collapse', {
		start() {
			if (!show) {
				node.style.height = `${node.offsetHeight}px`;
			} else {
				height = node.offsetHeight;
				node.style.height = 0;
			}
		},
		active() {
			node.style.height = `${show ? height : 0}px`;
		},
		end() {
			node.style.height = '';
			done();
		},
	});
}

const animation = {
	enter(node, done) {
		return animate(node, true, done);
	},
	leave(node, done) {
		return animate(node, false, done);
	},
};

class SidebarCustomizer extends Component {

	constructor(props) {
		super(props);

		this.state = {
			customerId:null,
			customerName:"",
			saveType:"",
			treeData: [],
			fetching: false,
			saving: false,
			selectedKeys: [],
			checkedKeys: [],
			halfCheckedKeys: [],
			overlayDivStyle: {display: "none"},
			spinnerStyle: {display: "none"}
		};
	}

	componentDidMount() {

		let self = this;
        let ignoredHalfCheckedKeys = [1,44];
		let customerId = this.props.match.params.customerId;
		let url = "/user/fetchSidebarData/user";
		let customerNameUrl = "/user/fetchUserName";

		if(!!customerId){
			url = `/user/fetchSidebarData/user/${customerId}`
			customerNameUrl = `/user/fetchUserName/${customerId}`;
		}

		let params = {
			url: url,
			method: "post"
		}

		let customerNameParams = {
			url  :customerNameUrl,
			method: "post"
		}

		self.setState({fetching: true, customerId})

		request(customerNameParams).then((response) => {

			self.setState({customerName: response.data});

			request(params).then((response) => {
				let data = response.data;
				let treeData = data.treeData;
				let checkedKeys = data.checkedKeys;
				checkedKeys = [...new Set([ ...checkedKeys])];

				for (let index in treeData) {
					self.convertChildrenToArray(treeData, index);
				}

				this.generateHalfChecked(treeData,checkedKeys);

			}).catch((error) => {
				throw error
			})
		}).catch((error) => {
			showAxiosError(error);
		}).then(() => {
			self.setState({fetching: false})
		})
	}

	generateHalfChecked = (treeData,checkedKeys) =>{
		let halfCheckedKeys =[];
		let treeArray = [];
		for(let flItem of treeData){ //1. level
			if(flItem.children !== null){
				treeArray = treeArray.concat(flItem.children);
				for (let slItem of flItem.children) { //2.level
					if(slItem.children !== null) {
						treeArray = treeArray.concat(slItem.children)
					}
				}
			}
		}

		halfCheckedKeys = treeArray.filter(item => checkedKeys.includes(item.key.toString()) || checkedKeys.includes(item.key)).map(children => children.parent);
		//add also halfcheckedkeys' parents as halfchecked
		halfCheckedKeys = halfCheckedKeys.concat(treeArray.filter(item => halfCheckedKeys.includes(item.key.toString()) || halfCheckedKeys.includes(item.key)).map(children => children.parent))

		if (checkedKeys.includes(45)){ //
			checkedKeys = checkedKeys.filter(item => item !== 45);
			halfCheckedKeys = halfCheckedKeys.concat([45]);
		}

		halfCheckedKeys = [...new Set([ ...halfCheckedKeys])];

		checkedKeys = checkedKeys.filter(key => !(halfCheckedKeys.includes(Number(key))));

		this.setState({treeData : treeData, checkedKeys : checkedKeys, halfCheckedKeys})
	}

	onClickSave = (e, type) => {
		e.preventDefault();
		let self = this;
		let {checkedKeys,halfCheckedKeys, customerId} = this.state;
		for (let i=0; i<halfCheckedKeys.length;i++)
			checkedKeys.push(halfCheckedKeys[i]);

		halfCheckedKeys=[];

		let allKeys = [...new Set([...checkedKeys, ...halfCheckedKeys])];

		let url = `/user/saveSidebarData/user`

		if(!!customerId)
			url = `/user/saveSidebarData/user/${customerId}`

		let params = {
			url: url,
			method: "post",
			data: allKeys
		}

		self.setState({saving: true, saveType: type})

		this.overlayPage();
		request(params).then((response) => {
			if(!customerId)
				self.props.updateUserHook(response.data)

			Alert.success("Kaydedildi" , {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}).catch((error) => {
			showAxiosError(error);
		}).then(() => {
			self.setState({
				saving: false,
				overlayDivStyle: {display: "none"},
				spinnerStyle: {display: "none"}
			},()=> {
				if(self.props.location.source === 'userList' && type === "saveClose")self.props.history.push(`/userList`)
				if(self.props.location.source === 'cUserList' && type === "saveClose")self.props.history.push(`/cUserList`)
			});
		})
	}

	overlayPage = () => {
		let overlayDivStyle = {};
		let spinnerStyle = {};

		let offsetWidth = document.getElementById('contentDiv').offsetWidth;
		let offsetHeight = document.getElementById('contentDiv').offsetHeight;
		overlayDivStyle.position = 'absolute';
		overlayDivStyle.zIndex = '1';
		overlayDivStyle.background = 'white';
		overlayDivStyle.opacity = '0.5';
		overlayDivStyle.width = offsetWidth;
		overlayDivStyle.height = offsetHeight;

		spinnerStyle.position = 'fixed';
		spinnerStyle.zIndex = '2';
		spinnerStyle.left = '56%';
		spinnerStyle.top = '50%';
		spinnerStyle.fontSize = '50px';

		this.setState({overlayDivStyle, spinnerStyle})
	}

	convertChildrenToArray = (treeData, element) => {

		if (treeData[element] && treeData[element]["children"]) {
			treeData[element]["children"] = Object.values(treeData[element]["children"])
			for (let index in treeData[element]["children"]) {
				this.convertChildrenToArray(treeData[element]["children"], index);
			}
		}
	}

	onGoBack = (e) => {
	let self = this;
		if (window.confirm('Kaydetmediğiniz değişiklikleriniz kaybolacak. Emin misiniz ?'))
			self.props.location.source === 'userList' ? self.props.history.push("/userList") :  self.props.history.push("/cUserList");

	}

	onSelect = (selectedKeys) => {
		this.setState({selectedKeys});
	};
	onCheck = (checkedKeys, info) => {
		this.generateHalfChecked(this.state.treeData,checkedKeys);
	};

	render() {
		let {treeData, fetching, saving, checkedKeys, selectedKeys,saveType, customerName,halfCheckedKeys} = this.state;

		return (
			<div className="row baseBackground">

					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>

						<StickButton position="leftSide" title="Kullanıcı Listesine Dön" label="Kullanıcı Listesine Dön"
									 className="zocial GeriDon" onClick={(e) => this.onGoBack(e)}/>
						<StickButton position="rightSide" title="Kaydet" label={saveType === "save" && saving? "Kaydediliyor..." : "Kaydet"}
									 disabled={saving} className="duzen3 zocial Kaydet" onClick={(e) => this.onClickSave(e, "save")}/>
						<StickButton position="rightSide" title="Kaydet & Kapat" label={saveType === "saveClose" && saving ? "Kaydediliyor..." : "Kaydet & Kapat"}
									 disabled={saving} className="zocial Kapat" onClick={(e) => this.onClickSave(e, "saveClose")}/>
					</NavBarKS>

				<div id="contentDiv" className="col-sm-12 satirBasi">
					<div className="row card-header">
						<h4 className="baslik card-title">Yan Menü Düzenleme
						<span className="float-right " style={ fetching ? {} : {color:"#4f7f9f",paddingRight: "11px"}}>{fetching ? "Yükleniyor.." : customerName}</span>
						</h4>
					</div>
					{fetching &&
					<h4 style={{color: "crimson"}}>Yükleniyor..</h4>
					}
					{treeData.length > 0 &&
					<Tree
						openAnimation={animation}
						showLine
						checkable
						selectable={false}
						defaultExpandAll
						onSelect={this.onSelect}
						onCheck={this.onCheck}
						selectedKeys={selectedKeys}
						checkedKeys={checkedKeys}
						treeData={treeData}
						halfCheckedKeys={halfCheckedKeys}
					/>}
				</div>
				<div id='overlayDiv' style={this.state.overlayDivStyle}/>
				<i className="fas fa-spinner fa-spin" style={this.state.spinnerStyle}/>
			</div>
		)
	}
}

export default SidebarCustomizer;